import { render } from "./SectorList.vue?vue&type=template&id=57cbd930"
import script from "./SectorList.vue?vue&type=script&lang=js"
export * from "./SectorList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__